module.exports = __webpack_public_path__ + "img/010022.7383e0a9.png";